<template>
  <div class="lh-container">
    <el-image :src="dataSource.value" :preview-src-list="[dataSource.value]"> </el-image>
  </div>
</template>

<script>
import { Image } from "element-ui";

export default {
  name: "lh-container",
  components: { [Image.name]: Image },
  props: {
    dataSource: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="less" scoped>
.lh-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  /deep/ .el-image {
    height: 100%;
    img {
      max-width: 100%;
      height: 100%;
      object-fit: cover;
      transform: scale(0.9);
    }
  }
}
</style>
